import { ApiKeySettings } from '@/types/settings';

export async function updateApiKeys(apiKeys: ApiKeySettings): Promise<ApiKeySettings> {
  try {
    // Save to localStorage
    const existingSettings = localStorage.getItem('app-settings');
    let settings = existingSettings ? JSON.parse(existingSettings) : {};
    
    settings.apiKeys = apiKeys;
    localStorage.setItem('app-settings', JSON.stringify(settings));
    
    // Also sync with setup configuration for backward compatibility
    const setupConfig = localStorage.getItem('setup-config');
    if (setupConfig) {
      const parsed = JSON.parse(setupConfig);
      parsed.apiKeys = {
        openWeatherMapKey: apiKeys.openWeatherMapKey,
        newsApiKey: apiKeys.newsApiKey,
      };
      localStorage.setItem('setup-config', JSON.stringify(parsed));
    }
    
    return apiKeys;
  } catch (error) {
    throw new Error(`Failed to update API keys: ${error}`);
  }
}